import { render, staticRenderFns } from "./imgView.vue?vue&type=template&id=696a0790&scoped=true&"
import script from "./imgView.vue?vue&type=script&lang=js&"
export * from "./imgView.vue?vue&type=script&lang=js&"
import style0 from "./imgView.vue?vue&type=style&index=0&id=696a0790&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a0790",
  null
  
)

export default component.exports